import React from "react";
import { IconGitCommit } from "@tabler/icons-react";
import { commitUrl, shortSha } from "../promptsCommit";

// A pinned florence-prompts commit: short SHA linked to its GitHub commit page (prompt pinning).
export default function CommitLink({ sha, icon = true, title }) {
  const url = commitUrl(sha);
  if (!url) return <span className="muted">—</span>;
  return (
    <a className="commit-link mono" href={url} target="_blank" rel="noopener noreferrer"
       title={title || `florence-prompts commit ${sha}`}>
      {icon && <IconGitCommit size={13} />}{shortSha(sha)}
    </a>
  );
}
